module.exports = __webpack_public_path__ + "img/P43920580Fweater.65972820.jpg";